/* @flow */

import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';

import styles from './SecondaryTag.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import ConditionalWrapper from 'src/shared/ui/component/misc/ConditionalWrapper';

import { capitalize } from 'src/shared/core/util/stringUtil';
import classNames from 'classnames';

type Props = {
  children: React.Node,
  postfix?: string,
  handleClick?: (string) => void,
  tooltip?: string,
  layoutClass?: string,
};

const useStyles = createUseThemeStyles(styles);

const SecondaryTag = ({
  children,
  handleClick,
  postfix,
  tooltip,
  layoutClass,
}: Props): React.Node => {
  const isClickable = !!handleClick;
  const text = typeof children === 'string' ? capitalize(children) : children;

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onClick = handleClick
    ? () => {
        if (typeof children === 'string') {
          handleClick(children);
        }
      }
    : null;

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <ConditionalWrapper
      condition={!!tooltip}
      wrapper={(children) => (
        <Tooltip title={tooltip} arrow>
          {children}
        </Tooltip>
      )}
    >
      <span
        tabIndex={tooltip ? 0 : -1}
        className={classNames(classes.root, layoutClass)}
        onClick={isClickable ? onClick : undefined}
      >
        {text} {postfix && <span className={classes.postfix}>{postfix}</span>}
      </span>
    </ConditionalWrapper>
  );
};

export default React.memo<Props>(SecondaryTag);
